import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ReceiptText, CreditCard } from 'lucide-react';

const StudentBillingPage: React.FC = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">Billing</h1>
        <p className="text-gray-400">Manage subscriptions and payment activity.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="">
          <CardHeader>
            <CardTitle className="text-foreground flex items-center gap-2">
              <ReceiptText className="w-5 h-5" />
              Subscriptions
            </CardTitle>
            <CardDescription>View plans, renewals, and subscription status.</CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to="/billing/subscriptions">Open Subscriptions</Link>
            </Button>
          </CardContent>
        </Card>

        <Card className="">
          <CardHeader>
            <CardTitle className="text-foreground flex items-center gap-2">
              <CreditCard className="w-5 h-5" />
              Payments
            </CardTitle>
            <CardDescription>Review invoice history and payment records.</CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to="/billing/payments">Open Payments</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default StudentBillingPage;

